import React from 'react';
import { Helmet } from 'react-helmet';
import {
  WithContext,
} from 'schema-dts';

import { CorpAllPagesStructuredDataProps } from '../definitions';

const CorpAllPagesStructuredData: React.FC<CorpAllPagesStructuredDataProps> = ({ context }) => {

  if (!context?.site?.name) {
    return null;
  }

  const websiteData: WithContext<any> = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": "https://www.cpaaustralia.com.au/#organization",
    "name": "CPA Australia",
    "url": "https://www.cpaaustralia.com.au/",
    "logo": "https://www.cpaaustralia.com.au/-/jssmedia/Project/CPA/Corporate/images/logos/CPA-Australia-logos/CPAA_RGB.jpg",
    "sameAs": [
      "https://www.facebook.com/cpaaustralia",
      "https://www.linkedin.com/school/cpaaustralia",
      "https://www.instagram.com/cpaaustralia/",
      "https://twitter.com/cpaaustralia"
    ]
  }

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(websiteData)}
      </script>
    </Helmet>
  );
};

export default CorpAllPagesStructuredData;
